export default "__VITE_ASSET__LTHJXQem__"